import { getHashedEmail, queueAnalyticsEvent, SeoEvent } from 'lib/gtm'

interface NewsletterSignupCustomer {
  id: string
  firstName: string
  lastName: string
}

interface NewsletterSignupAddress {
  street: string
  houseNumber: string
  flatNumber?: string | null
  city: string
  postalCode: string
}

export const gtmNewsletterSignupEvent = (
  email: string,
  customer?: NewsletterSignupCustomer,
  mainAddress?: NewsletterSignupAddress
) => {
  const hashedEmail = getHashedEmail(email)

  if (customer) {
    const dataLayerPayload = {
      event: SeoEvent.NEWSLETTER_SIGNUP, //constant
      type: 'other events', //constant
      user_id: customer.id, //User ID from crm if logged in, if not we return undefined
      user_adult: undefined, //1 if user have more than 18 years, 0 - if no, if no value we return undefined
      hashed_email: hashedEmail, //customer email in md5 - if logged in, if not we return undefined
      method: 'email', //login method
      user_data: {
        email: email,
        address: {
          first_name: customer.firstName,
          last_name: customer.lastName,
          street: mainAddress
            ? `${mainAddress.street} ${mainAddress.houseNumber}${
                mainAddress.flatNumber ? `/${mainAddress.flatNumber}` : ''
              }`
            : undefined,
          city: mainAddress?.city || undefined,
          region: mainAddress?.postalCode || undefined,
          postal_code: mainAddress?.postalCode || undefined,
          country: 'PL'
        }
      }
    }

    queueAnalyticsEvent(dataLayerPayload)
  } else {
    const dataLayerPayload = {
      event: SeoEvent.NEWSLETTER_SIGNUP, //constant
      type: 'other events', //constant
      hashed_email: hashedEmail,
      method: 'email',
      user_data: {
        email: email
      }
    }

    queueAnalyticsEvent(dataLayerPayload)
  }
}
